import styled from 'styled-components'

export const Component = styled.div`
  position: fixed;
  left: 350px;
  width: calc(100vw - 350px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #414A56;
`
